export default __webpack_public_path__ + "static/media/cover.02e95bf8.png";